import { z } from 'zod';
import { AxonEventSchema } from './event.types.js';

export const TaggedActivityEventSchema = z
  .object({
    event: AxonEventSchema,
    agentId: z.string(),
    agentName: z.string(),
  })
  .meta({ id: 'TaggedActivityEvent' });
export type TaggedActivityEvent = z.infer<typeof TaggedActivityEventSchema>;

export const RecentActivityResponseSchema = z.object({
  items: z.array(TaggedActivityEventSchema),
});
export type RecentActivityResponse = z.infer<typeof RecentActivityResponseSchema>;
